import * as angular from "angular";

angular.module("app.services", []);
